import React from "react";
import { Button } from "@mui/material";
import { PropTypes } from "prop-types";
import { useNavigate } from "react-router-dom";

const ActionButtons = ({ onNextStep, onCancel, nextLabel="Continuer" }) => {
  const navigate = useNavigate();

  return (
    <>
      <Button
        size="large"
        variant="outlined"
        disableElevation
        color="secondary"
        type="button"
        onClick={() => navigate("/")}
      >
        Annuler
      </Button>

      <Button
        size="large"
        variant="outlined"
        disableElevation
        color="success"
        type="button"
        onClick={onNextStep}
      >
        {nextLabel}
      </Button>
    </>
  );
};

export default ActionButtons;

ActionButtons.propTypes = {
  onNextStep: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};

ActionButtons.defaultProps = {
  onCancel: null,
};
